import React from 'react'
import styled from 'styled-components'

// flex from the layout section
import { Flex } from '../styleguide/layout';

// app store icons 
import GooglePlay from "../../assets/GooglePlay.png";
import AppStore from "../../assets/AppleStore.png";

const AppStoreLinks = () => {
  return (
    <Flex margin=".875rem 0 0 -1rem" direction="row" gap="0">
        <AppIcon href="https://app.google.com">
            <img src={GooglePlay} alt="google play" loading='lazy' />
        </AppIcon>
        <AppIcon href="https://app.ios-store.com">
            <img src={AppStore} alt="apple store" loading='lazy' />
        </AppIcon>
    </Flex>
  )
}

export default AppStoreLinks

const AppIcon = styled.a`
  width: 50%;

  img {
    width: 100%;
    height: auto;
  }
`